var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfilePic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1920.000000pt",
    height: "1920.000000pt",
    viewBox: "0 0 1920.000000 1920.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1920.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9440 14630 c-577 -39 -1100 -239 -1570 -600 -114 -88 -370 -342 -463 -459 -554 -701 -748 -1612 -527 -2475 262 -1025 1079 -1819 2115 -2056 227 -51 353 -64 630 -64 266 0 379 11 600 59 774 167 1445 657 1850 1350 427 733 498 1654 188 2445 -292 743 -873 1322 -1624 1619 -350 137 -813 208 -1199 181z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7219 9650 c-818 -325 -1447 -802 -1886 -1428 -386 -552 -610 -1233 -656 -1990 l-3 -63 155 -108 c1217 -841 2595 -1337 4070 -1466 225 -20 712 -37 866 -30 66 2 185 7 265 10 1362 53 2780 488 3975 1218 149 91 457 296 496 329 l26 23 -8 125 c-91 1330 -719 2368 -1839 3040 -205 123 -568 296 -767 366 l-52 18 -108 -105 c-456 -444 -1037 -729 -1693 -830 -196 -31 -645 -33 -840 -6 -685 98 -1258 380 -1765 869 l-90 86 -146 -58z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfilePic);
export default __webpack_public_path__ + "static/media/DefaultProfilePic.71640cf86e346c58a8d4611d459365b2.svg";
export { ForwardRef as ReactComponent };